export default __webpack_public_path__ + "static/media/santa-maria-1.d8a38a22.jpg";